// extracted by mini-css-extract-plugin
export default {"box":"box_box__8C3dF","win":"box_win__Z-nf6","lose":"box_lose__yaojx","tie":"box_tie__dBlIx","img":"box_img__zdDJ2"};